import {
  httpClient,
  apiRoutes,
  type DefaultQueryError,
} from '@ahm/api-wrappers-core';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import type { ProgressesSubDetailResponse } from './types';

export const getProgressesSubscriptionDetailFn = async (id: string) => {
  const response = await httpClient.get<ProgressesSubDetailResponse>(
    apiRoutes.subscription.progresses_subscription_detail(id)
  );
  return response.data;
};

export const useGetProgressesSubscriptionDetail = (
  id: string,
  opts?: Omit<
    UseQueryOptions<ProgressesSubDetailResponse, DefaultQueryError>,
    'queryKey'
  >
) =>
  useQuery<ProgressesSubDetailResponse, DefaultQueryError>({
    queryKey: [apiRoutes.subscription.progresses_subscription_detail(id)],
    queryFn: () => getProgressesSubscriptionDetailFn(id),
    ...opts,
  });
